import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function Fotovoltaico() {
  return (
    <SpecializationPage
      testid="fotovoltaico-page"
      quoteService="Efficientamento energetico (fotovoltaico)"
      index="/ 07"
      title="Efficientamento Energetico"
      lines={["Efficientamento", "energetico."]}
      subtitle="Produci la tua energia e abbatti i costi in bolletta grazie all'installazione di impianti fotovoltaici ad alto rendimento, integrati nel tuo immobile."
      image={IMG.solar}
      accent="Energia pulita, indipendenza e risparmio."
      intro={[
        "Progettiamo e installiamo impianti fotovoltaici su misura per abitazioni ed edifici residenziali. Analizziamo consumi, esposizione e superfici disponibili per dimensionare l'impianto più efficiente per le tue esigenze.",
        "L'efficientamento energetico non significa solo risparmio: aumenta il valore dell'immobile, migliora la classe energetica e riduce drasticamente le emissioni. Con l'abbinamento a sistemi di accumulo, l'autoconsumo diventa massimo.",
      ]}
      specs={[
        { k: "Rendimento moduli", v: "fino al 22%" },
        { k: "Risparmio bolletta", v: "fino al 70%" },
        { k: "Accumulo", v: "Opzionale" },
        { k: "Monitoraggio", v: "Da app" },
        { k: "Vita utile", v: "> 25 anni" },
        { k: "Manutenzione", v: "Minima" },
      ]}
      benefits={[
        { t: "Risparmio immediato", d: "Riduci fino al 70% i costi in bolletta autoproducendo energia." },
        { t: "Indipendenza energetica", d: "Con l'accumulo utilizzi la tua energia anche di sera e nei picchi di consumo." },
        { t: "Valore dell'immobile", d: "Un immobile efficiente vale di più ed è più appetibile sul mercato." },
        { t: "Sostenibilità", d: "Energia 100% pulita e rinnovabile, con azzeramento delle emissioni." },
        { t: "Incentivi fiscali", d: "Ti guidiamo tra detrazioni e agevolazioni disponibili." },
        { t: "Monitoraggio smart", d: "Controlli produzione e consumi in tempo reale da smartphone." },
      ]}
      applications={[
        "Coperture residenziali (a falda e piane)",
        "Tetti in tegole, coppi e lamiera",
        "Pensiline e tettoie",
        "Carport e posti auto coperti",
        "Sistemi di accumulo con batterie",
        "Colonnine di ricarica per auto elettriche",
        "Edifici plurifamiliari e condomini",
        "Ville e villette unifamiliari",
        "Impianti a terra su terreni e giardini",
        "Aziende agricole e capannoni",
        "Solare termico per acqua calda sanitaria",
        "Integrazione con pompe di calore",
        "Sistemi di monitoraggio e domotica",
        "Comunità energetiche rinnovabili (CER)",
        "Riqualificazione energetica dell'immobile",
        "Interventi con detrazioni e incentivi",
      ]}
      faqs={[
        { q: "Quanto posso risparmiare in bolletta con il fotovoltaico?", a: "Autoproducendo energia si può ridurre fino al 70% il costo della bolletta elettrica. Il risparmio effettivo dipende dai consumi, dall'esposizione e dalla presenza di un sistema di accumulo." },
        { q: "Conviene installare le batterie di accumulo?", a: "L'accumulo permette di utilizzare l'energia prodotta di giorno anche di sera e nei picchi di consumo, massimizzando l'autoconsumo e l'indipendenza dalla rete. Valutiamo insieme la soluzione più conveniente per le tue abitudini." },
        { q: "Ci sono incentivi o detrazioni fiscali?", a: "Sì. Esistono detrazioni e agevolazioni per gli impianti fotovoltaici e l'efficientamento energetico. Ti guidiamo tra le opzioni disponibili e la relativa documentazione." },
        { q: "Quanto dura un impianto fotovoltaico?", a: "I moduli hanno una vita utile superiore a 25 anni con manutenzione minima. Le prestazioni si mantengono elevate nel tempo con un decadimento molto contenuto." },
        { q: "Posso controllare produzione e consumi?", a: "Sì. Gli impianti che installiamo sono dotati di sistemi di monitoraggio che permettono di controllare produzione e consumi in tempo reale, comodamente da smartphone." },
      ]}
    />
  );
}
